import { DurationType } from "generated/graphql"
import React from "react"

type DurationProps = {
  duration: DurationType
}

/**
 * @description Displays duration data in a human readable format
 * @example
 * import Duration from "components/Atoms/Duration"
 *
 * <Duration duration={{ hours: 30, minutes: 15, seconds: 30 }} />
 * <Duration duration={{ hours: 30 }} />
 * <Duration duration={{ minutes: 30 }} />
 *
 * @author Malik Bagwala <malik.bagwala@vesatogo.com>
 */
const Duration = ({ duration }: DurationProps) => {
  if (!duration) return <span data-cy="duration">na</span>
  return (
    <span data-cy="duration">
      {duration.hours ? (
        <>
          {duration.hours}
          <sub data-cy="duration-h" className="text-gray-700">
            h
          </sub>{" "}
        </>
      ) : null}
      {duration.minutes ? (
        <>
          {duration.minutes}
          <sub data-cy="duration-m" className="text-gray-700">
            m
          </sub>{" "}
        </>
      ) : null}
      {duration.seconds ? (
        <>
          {duration.seconds}
          <sub data-cy="duration-s" className="text-gray-700">
            s
          </sub>
        </>
      ) : null}
    </span>
  )
}

export default Duration
